import { create } from 'zustand';

const STORAGE_KEY = 'newUpdatesModalSeen';

const useNewUpdatesModalStore = create((set) => ({
  // Modal state
  isOpen: false,

  // Actions
  setIsOpen: (isOpen) => set({ isOpen }),

  // Show modal for all users after login (no endpoint tracking needed)
  showModal: () => {
    set({ isOpen: true });
  },

  // Handle modal close - save to localStorage
  handleClose: () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    set({ isOpen: false });
  },

  // Handle open changelog action - save to localStorage
  handleOpenChangelog: () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    set({ isOpen: false });
  },

  // Reset store (for logout) - clear localStorage
  reset: () => {
    localStorage.removeItem(STORAGE_KEY);
    set({ isOpen: false });
  }
}));

export default useNewUpdatesModalStore;

